// extracted by mini-css-extract-plugin
export default {"grid":"Portfolio_grid__Ohzdr","gridItem":"Portfolio_gridItem__UkDZE"};